<template>
  <h1>NOT FOUND</h1>
</template>

<script>
export default {
    name: "404"
}
</script>

<style>

</style>